/*

MeganeTemplate

Version: 4.1.0
Website: http://megane-template.com/
License: Dentsu Isobar All Rights Reserved.

*/

export default class jSmoothScroll {

    constructor(selector, option) {

        this.selector = selector;

        //option
        if(option == null) option = {};
        this.speed = option.speed ? option.speed : 800;
        this.easing = option.easing ? option.easing : "linear";
        this.posFix = option.posFix ? option.posFix : 0;
        this.ignore = option.ignore ? option.ignore : "";
        this.blank = option.blank ? option.blank : false;
        this.pagetop = option.pagetop ? option.pagetop : "#j-pagetop";
        this.customAnchor = option.customAnchor ? option.customAnchor : "#/";

        this.ScrollEnd = function(){};

        this.Init();
        
        if ( this.blank ) {
            this.AnchorLink();
        }

    }
    

    /**
    **
    ** Init
    **
    **/
    Init() {

        const THAT = this;
        
        $(this.selector).not(this.ignore).off("click");
        

        $(this.selector).not(this.ignore).on("click", function (e) {
            
            var href = $(this).attr("href");
            
            if (href && href.split("#")[0] == "") {
                
               
                e.preventDefault();
                var target = $(href == "#" || href == "" ? 'htsml' : href);
                var position;
                if (href == THAT.pagetop) {   
                    position = 0;
                }
                else {
                    position = target.offset().top
                }

                THAT.SmoothScroll(position);

            }

        });

    }

    /**
    **
    ** SmoothScroll
    **
    **/
    SmoothScroll(position) {

        var endFlag = true;

        $('html,body').animate(
            {
                scrollTop: position - this.posFix
            },
            {
                duration: this.speed,
                easing: this.easing,
                complete: () => {
                    if(endFlag){
                        this.ScrollEnd();
                        this.Init();
                        endFlag = false;
                    }
                }
            }
        );

    }

    /**
    **
    ** AnchorLink
    **
    **/
    AnchorLink() {

        const THAT = this;

        $(this.selector).not(this.ignore).each(function() {

            var thisHref = $(this).attr("href");

            if( thisHref ) {

                var hrefSplit = thisHref.split("#");

                if( (hrefSplit.length > 1) && (hrefSplit[0] != "") ) {

                    $(this).attr( "href", thisHref.replace( /#/g , THAT.customAnchor ));

                }

            }

        });

        if( location.href.split(this.customAnchor)[1] ){

            var position = $("#"+ location.href.split(this.customAnchor)[1] ).offset().top;
            this.SmoothScroll(position);

        }

    }


}
